import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import emptyStateImage from '../../../../assets/images/emptytstate.svg';
import { Plus } from '../Icons/Icons';

const EmptyState = ({
  pageType, onAdd, minHeight = 'min-h-[60vh]', dataTestId = undefined,
}) => {
  const singularPageType = pageType.toLowerCase().slice(0, -1);
  return (
    <div className={`flex items-center justify-center ${minHeight} `}>
      <div className="flex flex-col items-center justify-center text-center vamos-white">
        <img
          src={emptyStateImage}
          alt={`${pageType} empty state illustration`}
          className="mb-4"
        />
        <h2 className="font-sans text-2xl font-bold leading-tight text-center text-vamos-gray mb-1">
          Your {pageType} page is empty.
        </h2>
        <p className="font-sans text-base font-normal leading-relaxed text-center text-vamos-gray mb-10.5">
          Add a {singularPageType} to view and edit it here.
        </p>
        { pageType !== 'visits' && pageType !== 'notes' && (
        <Button
          label={`New ${singularPageType}`}
          onClick={onAdd}
          className="mb-4"
          Icon={Plus}
          aria-label={`Add new ${singularPageType}`}
          dataTestId={dataTestId}
        />
        )}
        <a
          href="https://docs.google.com/document/d/1M7dB9txljYhpIDLA7gDzMoGdD2qVJ7XZcnvUSu7GwUY/edit?usp=sharinge"
          target="_blank"
          rel="noopener noreferrer"
          className="font-sans text-lg font-normal text-vamos-black underline hover:text-vamos-gray visited:text-vamos-green4 active:text-vamos-green1"
          aria-label="View user guide"
        >
          Or view user guide
        </a>
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  pageType: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
  minHeight: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default EmptyState;
